// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Modal-ModalTitle-module--cls1--2K_5N","cls2":"Modal-ModalTitle-module--cls2--47xGX Modal-ModalTitle-module--cls1--2K_5N"};